"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _StyledSettingsComponents = require("./StyledSettingsComponents");

var _Row = _interopRequireDefault(require("./Row"));

var _Input = _interopRequireDefault(require("./Input"));

var _settings = require("../../constants/settings");

var _CurrentContext = _interopRequireDefault(require("../context/CurrentContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    & > div:first-of-type {\n        margin-right: 10px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Inputs = _styledComponents.default.div(_templateObject());

var SizePanel =
/*#__PURE__*/
function (_Component) {
  _inherits(SizePanel, _Component);

  function SizePanel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SizePanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SizePanel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.disabledProp = function (path) {
      var type = _this.props.type;
      var settings = _settings.TRANSFORM_SETTINGS[type];
      return settings && (0, _ramda.has)(path, settings) && !settings[path];
    };

    _this.parseWidth = function (value, current) {
      var _current$scaleX = current.scaleX,
          scaleX = _current$scaleX === void 0 ? 1 : _current$scaleX;
      return Math.abs(Math.round((isNaN(value) ? 0 : value) * scaleX));
    };

    _this.formatWidth = function (value, current) {
      var _current$scaleX2 = current.scaleX,
          scaleX = _current$scaleX2 === void 0 ? 1 : _current$scaleX2;
      return Math.abs(Math.round((isNaN(value) ? 0 : value) / scaleX));
    };

    _this.parseHeight = function (value, current) {
      var _current$scaleY = current.scaleY,
          scaleY = _current$scaleY === void 0 ? 1 : _current$scaleY;
      return Math.abs(Math.round((isNaN(value) ? 0 : value) * scaleY));
    };

    _this.formatHeight = function (value, current) {
      var _current$scaleY2 = current.scaleY,
          scaleY = _current$scaleY2 === void 0 ? 1 : _current$scaleY2;
      return Math.abs(Math.round((isNaN(value) ? 0 : value) / scaleY));
    };

    _this.onChangeX = function (x, current, onChange) {
      if (current.anchors) {
        var headAnchor = (0, _ramda.head)(current.anchors);
        var xDifference = x - headAnchor.x;
        var anchors = current.anchors.map(function (a) {
          return _objectSpread({}, a, {
            x: a.x + xDifference
          });
        });
        onChange(_objectSpread({}, current, {
          x: x,
          anchors: anchors
        }));
      }
    };

    _this.onChangeY = function (y, current, onChange) {
      if (current.anchors) {
        var headAnchor = (0, _ramda.head)(current.anchors);
        var yDifference = y - headAnchor.y;
        var anchors = current.anchors.map(function (a) {
          return _objectSpread({}, a, {
            y: a.y + yDifference
          });
        });
        onChange(_objectSpread({}, current, {
          y: y,
          anchors: anchors
        }));
      }
    };

    return _this;
  }

  _createClass(SizePanel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement(_StyledSettingsComponents.Panel, null, !this.disabledProp('resizeEnabled') && _react.default.createElement(_Row.default, {
        label: "\u0420\u0430\u0437\u043C\u0435\u0440"
      }, _react.default.createElement(Inputs, null, _react.default.createElement(_Input.default, {
        prop: "width",
        small: "\u0448\u0438\u0440\u0438\u043D\u0430",
        parse: this.parseWidth,
        format: this.formatWidth,
        isNumber: true
      }), _react.default.createElement(_Input.default, {
        prop: "height",
        small: "\u0432\u044B\u0441\u043E\u0442\u0430",
        parse: this.parseHeight,
        format: this.formatHeight,
        isNumber: true
      }))), _react.default.createElement(_Row.default, {
        label: "\u041F\u043E\u0437\u0438\u0446\u0438\u044F"
      }, _react.default.createElement(_CurrentContext.default.Consumer, null, function (_ref) {
        var current = _ref.current,
            _onChange = _ref.onChange;
        return _react.default.createElement(Inputs, null, _react.default.createElement(_Input.default, {
          prop: "x",
          small: "\u0441\u043B\u0435\u0432\u0430",
          isNumber: true,
          onChange: function onChange(x) {
            return _this2.onChangeX(x, current, _onChange);
          }
        }), _react.default.createElement(_Input.default, {
          prop: "y",
          small: "\u0441\u0432\u0435\u0440\u0445\u0443",
          isNumber: true,
          onChange: function onChange(y) {
            return _this2.onChangeY(y, current, _onChange);
          }
        }));
      })), !this.disabledProp('rotateEnabled') && _react.default.createElement(_Row.default, {
        label: "\u041F\u043E\u0432\u043E\u0440\u043E\u0442"
      }, _react.default.createElement(_Input.default, {
        prop: "rotation",
        small: "\u0443\u0433\u043E\u043B",
        isNumber: true
      })));
    }
  }]);

  return SizePanel;
}(_react.Component);

exports.default = SizePanel;
SizePanel.propTypes = {
  type: _propTypes.default.string
};